/**=========================================================
 * Module: offer.js
 * Offer Controller
 =========================================================*/

App.controller('OfferController',
  ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'DataService', 'ngDialog', '$filter','toaster',
  function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D, ngDialog, $filter, toaster) {
    "use strict";

        // input cambiato => updateOffer(false, true)
        // caricamento offerta => updateOffer()
        // offerta salvata => updateOffer(lang)
      $scope.updateOffer = function(saved, forceDisable){
        if($scope.analysis && $scope.model && $scope.project){
            var discountFuzzy = $scope.analysis.mt && $scope.project.createdOn<1681768800000 ? 50 : $scope.project.discountNo; //important: discountNo, non discountFuzzy
            var discountNo = $scope.analysis.mt && $scope.project.createdOn<1681768800000 ? 50 : $scope.project.discountNo;
            if(!$scope.analysis.mt) discountFuzzy = $scope.project.discountFuzzy; //important!!!
            $scope.model.total = Math.round((parseFloat($scope.model.pagination || 0) + parseFloat($scope.model.extra || 0) +
                (Math.round($scope.analysis.contextMatch * ((100-$scope.project.discountContext) / 100)) * parseFloat($scope.model.rate)) +
                (Math.round($scope.analysis.fullMatch * ((100-$scope.project.discountFull) / 100)) * parseFloat($scope.model.rate)) +
                (Math.round($scope.analysis.fuzzyMatch * ((100-discountFuzzy) / 100)) * parseFloat($scope.model.rate)) +
                (Math.round($scope.analysis.noMatch * ((100-discountNo) / 100)) * parseFloat($scope.model.rate)))* 1000) / 1000;
            if(isNaN($scope.model.total)) $scope.model.total = 0;
            $scope.$parent.updateOffer($scope.model.total, $scope.dest, saved, forceDisable);
        }
      };

      $scope.changedOffer = function(){
          $scope.updateOffer(false, true);
          $scope.$parent.setOfferDirty($scope.model.destination, true)
          $scope.form.status = ''
      }

      $scope.pop = function(type, title, text) {
          toaster.pop(type, title, text, 0, 'trustedHtml');
      };

      $scope.$watch('analysis', function(){
                    $scope.updateOffer();
                    init();
                });

      var init = function () {
          if($scope.analysis){
              D.load('offer', $scope.project.id + '-' + $rootScope.user.group.id + '-' + $scope.dest)
                  .then(
                      function (response) {
                          $scope.model = response;
                          $scope.$parent.$parent.offers[$scope.model.source + '_' + $scope.model.destination] = $scope.model;
                          if (!$scope.model.project)
                              $scope.model.project = $scope.project.id;
                          var labelTotal = $filter('translate')('fields.TOTALFOR', {
                              lang: $scope.dest
                          });
                          if($scope.analysis.normTotal===0) $scope.model.rate = 0.0;
                          $scope.form = {
                              title: '',
                              cls: 'form-stacked',
                              status: '',
                              type: 'offer',
                              model: $scope.model,
                              fields: [{
                                  available: true,
                                  type: $scope.project.status == 'ESTIMATION' ? 'decimal' : 'static',
                                  displayType: 'decimal',
                                  decimalSep: $rootScope.user.decimalSep,
                                  decimals: 3,
                                  name: 'rate',
                                  labelParams: { currency: ($scope.model.currency || $scope.project.currency)},
                                  onchange: $scope.changedOffer,
                                  labelColumn: 12,
                                  postfix: $filter('translate')('enums.currencySymbol.' + ($scope.model.currency || $scope.project.currency)),
                                  postfixClass: 'emphasizedFieldAddOn',
                                  disabled: $scope.analysis.normTotal === 0,
                                  required: $scope.analysis.normTotal > 0
                              }, {
                                  available: $scope.project.dtp && !($scope.project.opts && $scope.project.opts.noDtpInOffers),
                                  type: $scope.project.status == 'ESTIMATION' ? 'decimal' : 'static',
                                  displayType: 'decimal',
                                  decimalSep: $rootScope.user.decimalSep,
                                  decimals: 2,
                                  name: 'pagination',
                                  onchange: function(){
                                    if($scope.model.pagination===null || $scope.model.pagination===undefined || $scope.model.pagination==='' || isNaN($scope.model.pagination)){ $scope.model.pagination = 0 }
                                    $scope.changedOffer()
                                  },
                                  labelParams: { currency: ($scope.model.currency || $scope.project.currency)},
                                  labelColumn: 12,
                                  postfix: $filter('translate')('enums.currencySymbol.' + ($scope.model.currency || $scope.project.currency)),
                                  postfixClass: 'emphasizedFieldAddOn',
                                  required: $scope.project.dtp
                              }, {
                                  available: true,
                                  type: $scope.project.status == 'ESTIMATION' ? 'decimal' : 'static',
                                  displayType: 'decimal',
                                  decimalSep: $rootScope.user.decimalSep,
                                  decimals: 2,
                                  name: 'extra',
                                  onchange: function(){
                                    if($scope.model.extra===null || $scope.model.extra===undefined || $scope.model.extra==='' || isNaN($scope.model.extra)){ $scope.model.extra = 0 }
                                    $scope.changedOffer()
                                  },
                                  labelParams: { currency: ($scope.model.currency || $scope.project.currency)},
                                  labelColumn: 12,
                                  postfix: $filter('translate')('enums.currencySymbol.' + ($scope.model.currency || $scope.project.currency)),
                                  postfixClass: 'emphasizedFieldAddOn',
                                  disabled: $scope.analysis.delivered === true,
                                  required: false
                              }, {
                                  available: true,
                                  type: 'static',
                                  displayType: 'currency',
                                  def: 0,
                                  decimals: 2,
                                  decimalSep: $rootScope.user.decimalSep,
                                  currency: $scope.model.currency || $scope.project.currency,
                                  name: 'total',
                                  labelParams: { currency: ($scope.model.currency || $scope.project.currency)},
                                  label: labelTotal,
                                  labelColumn: 12
                              }, {
                                  available: !$scope.$parent.offer.sent && !$scope.analysis.delivered,
                                  type: 'submit',
                                  name: 'empty',
                                  label: 'labels.SAVE',
                                  labelColumn: 12
                              }],
                              successLabel: 'labels.SUCCESSSAVE',
                              validate: function () {
                                  var errors = [];
                                  for (var i = 0; i < this.fields.length; i++) {
                                      var field = this.fields[i];
                                      if (field.available && field.required && !this.model[field.name]) {
                                          errors.push({
                                              field: field,
                                              error: 'required'
                                          });
                                      }

                                  }
                                  if (errors.length) {
                                      var errorMessages = "<ul>";
                                      for (var i = 0; i < errors.length; i++) {
                                          var e = errors[i];
                                          errorMessages += "<li>" +
                                              $filter('translate')('labels.VALIDATIONERROR' + e.error.toUpperCase(), {
                                                  name: $filter('translate')('fields.' + e.field.name.toUpperCase())
                                              }) +
                                              "</li>";
                                      }
                                      errorMessages += "</ul>";
                                      $scope.pop('error', $filter('translate')('labels.NOTVALIDFORM'), errorMessages);
                                      return false;
                                  } else return true;
                              },
                              submit: function () {
                                  if (this.validate()) {
                                      $scope.form.status = 'submitting';
                                      $scope.model.destination = $scope.dest;
                                      if($scope.model.extra===null || $scope.model.extra===undefined || $scope.model.extra==='' || isNaN($scope.model.extra)){ $scope.model.extra = 0 }
                                      D.save('offer', $scope.model).then(
                                          function (response) {
                                              $scope.form.status = 'submitted';
                                              $scope.$parent.offers[response.source + '_' + response.destination] = response;
                                              $scope.$parent.setOfferDirty($scope.model.destination, false)
                                              $scope.updateOffer(response.destination);

                                              //$scope.model = response;
                                              $scope.model.id = response.id;

                                              /*if(!$scope.model.project)
                                                  $scope.model.project = $scope.project.id;
                                              $scope.form.model = $scope.model;*/
                                          }
                                          
                                      ).catch(function (response) {
                                              $scope.form.status = 'error';
                                          });
                                  }
                              }
                          }
                          if($scope.analysis.delivered && !$scope.model.id){
                              $scope.form.submit()
                          }
                          $timeout(function () {
                              $scope.updateOffer();
                          }, 100);
                      }
                  ).catch(console.error);
                }
            }
        
        init();



  }
]);
